import React, { useState } from "react";
import { ThumbsUp, ThumbsDown, Heart, MoreVertical } from "lucide-react";
import { Post } from "../../../types/posts";
import { getRelativeTime } from "./YouTubePost";

const getChannelInitials = (name?: string) => {
  if (!name) return "YT";
  const parts = name
    .split(" ")
    .filter(Boolean)
    .map((n) => n[0])
    .join("")
    .toUpperCase();
  return parts.slice(0, 2) || "YT";
};

export function YouTubeVideoComment({ post }: { post: Post }) {
  const [expanded, setExpanded] = useState(false);
  const [imgError, setImgError] = useState(false);

  const COMMENT_LIMIT = 68;


  const isLong = (post?.footer ?? "").length > COMMENT_LIMIT;

const displayText =
  !expanded && isLong
    ? (post?.footer ?? "").slice(0, COMMENT_LIMIT)
    : post?.footer ?? "";

      const getHandle = (url?: string) => {
  if (!url) return "@handle-name";
  const atIndex = url.lastIndexOf("@");
  return atIndex !== -1 ? url.slice(atIndex + 1) : "@handle-name";
};

  return (
    <div className="flex justify-between items-start gap-4">

      {/* LEFT SECTION */}
      <div className="flex gap-3 flex-1 min-w-0 overflow-hidden">

        {/* Avatar */}
        {post?.userImage && !imgError ? (
          <img
            src={post.userImage}
            alt="channel avatar"
            className="w-9 h-9 rounded-full object-cover shrink-0"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-9 h-9 bg-gray-300 rounded-full flex items-center justify-center font-semibold text-sm shrink-0">
            {getChannelInitials(post?.displayName)}
          </div>
        )}

        {/* Content */}
        <div className="flex-1 min-w-0 overflow-hidden">

          {/* Row 1 - Name + Time */}
          <div className="flex items-center min-w-0 overflow-hidden">
            <span className="font-semibold text-sm bg-black text-white px-[6px] py-[1px] rounded truncate shrink min-w-0">
              @{getHandle(post?.profileUrl)}
            </span>
            <span className="text-gray-500 text-xs whitespace-nowrap shrink-0 ml-auto pl-1">{getRelativeTime(post)} ago</span>
          </div>

          {/* Row 2 - Comment Text */}
          <p className="text-sm text-gray-800 whitespace-pre-line mt-1 overflow-hidden" style={{ overflowWrap: "anywhere" }}>
            {displayText}
            {!expanded && isLong && "..."}
          </p>

          {/* Read More / Show Less */}
          {isLong && (
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-sm font-medium text-gray-700 mt-1"
            >
              {expanded ? "Show less" : "Read more"}
            </button>
          )}

          {/* Actions */}
          <div className="flex items-center gap-4 mt-3 text-gray-600">
            <button className="flex items-center gap-1 hover:text-black">
              <ThumbsUp size={16} />
            </button>

            <button className="flex items-center gap-1 hover:text-black">
              <ThumbsDown size={16} />
            </button>

            <button className="flex items-center gap-1 hover:text-black">
              <Heart size={16} />
            </button>

            <button className="text-sm font-medium hover:text-black">
              Reply
            </button>
          </div>

        </div>
      </div>

      {/* RIGHT SECTION - 3 DOTS */}
      <button className="text-gray-600 hover:text-black shrink-0 ml-2">
        <MoreVertical size={18} />
      </button>

    </div>
  );
}